import React, { useState, useEffect, useRef } from 'react'

const NetworkStatus = React.memo(() => {
  const [isOnline, setIsOnline] = useState(navigator.onLine)
  const [showNotification, setShowNotification] = useState(false)
  const intervalRef = useRef(null)

  useEffect(() => {
    const handleOnline = () => {
      setIsOnline(true)
      setShowNotification(true)
      setTimeout(() => setShowNotification(false), 3000)
    }

    const handleOffline = () => {
      setIsOnline(false)
      setShowNotification(true)
      setTimeout(() => setShowNotification(false), 5000)
    }

    window.addEventListener('online', handleOnline)
    window.addEventListener('offline', handleOffline)

    return () => {
      window.removeEventListener('online', handleOnline)
      window.removeEventListener('offline', handleOffline)
      if (intervalRef.current) {
        clearInterval(intervalRef.current)
        intervalRef.current = null
      }
    }
  }, [])

  // Don't show anything if online and no notification
  if (isOnline && !showNotification) {
    return null
  }

  return (
    <>
      {/* Persistent Status Bar */}
      {!isOnline && (
        <div className="fixed top-0 left-0 right-0 z-50 px-4 py-2 text-sm font-medium text-center bg-red-600 text-white">
          <div className="flex items-center justify-center space-x-2">
            <span>Offline - Limited functionality</span>
          </div>
        </div>
      )}

      {/* Connection Change Notification */}
      {showNotification && (
        <div
          className={`
            fixed top-16 left-4 right-4 mx-auto max-w-sm z-50 p-4 rounded-lg shadow-lg
            transform transition-all duration-500 ease-in-out
            ${isOnline 
              ? 'bg-green-600 text-white translate-y-0 opacity-100' 
              : 'bg-red-600 text-white translate-y-0 opacity-100'
            }
          `}
        >
          <div className="flex items-center space-x-3">
            <div className="flex-1">
              <p className="font-medium">
                {isOnline ? 'Back Online!' : 'Connection Lost'}
              </p>
              <p className="text-sm opacity-90">
                {isOnline 
                  ? 'Syncing pending changes...' 
                  : 'Working in offline mode'
                }
              </p>
            </div>
          </div>
        </div>
      )}

      {/* Add top padding to main content when status bar is visible */}
      {!isOnline && (
        <style>{`
          body {
            padding-top: 40px;
          }
        `}</style>
      )}
    </>
  )
})

export default NetworkStatus